export const isDark = useDark({
  onChanged(dark: boolean) {
    if (dark) {
      document.documentElement.classList.add('dark')
    }
  },
})
export const toggleDark = useToggle(isDark)
// export const preferredDark = usePreferredDark()
